import { FeedbackSentiment } from 'app/hooks/fetch/useFeedbackAnalytics';
import NegativeFeedbackButton from 'app/components/Feedback/NegativeFeedbackButton';
import PositiveFeedbackButton from 'app/components/Feedback/PositiveFeedbackButton';

export default function FeedbackForm({
  onClickFeedback,
  selected,
  feedbackQuestion,
}: {
  onClickFeedback: (feedbackSentiment: FeedbackSentiment) => void;
  selected?: FeedbackSentiment;
  feedbackQuestion?: string;
}) {
  return (
    <div className="inline-flex items-center gap-3 py-2 px-3 rounded-full border border-gray-200">
      <span className="text-sm text-typography-secondary">{feedbackQuestion}</span>
      <div className="flex items-center gap-3">
        <PositiveFeedbackButton
          onClick={onClickFeedback}
          filled={selected === FeedbackSentiment.POSITIVE}
        />
        <NegativeFeedbackButton
          onClick={onClickFeedback}
          filled={selected === FeedbackSentiment.NEGATIVE}
        />
      </div>
    </div>
  );
}
